import React, { FC, useState } from 'react'
import { useStoreon } from 'storeon/react'
import { GxButton, GxDropdown, GxMenu } from '@garpix/garpix-web-components-react'
import { api } from '@/api'
import { Events, State } from '@/interfaces'
import { objectKeys } from '@/utils'
import styles from './styles/styles.module.scss'
import { orderRates } from '../../helpers'
import { ITariffItem } from './interfaces'

interface IDropdownListTariff {
  data?: Record<string, any>
  time?: string
}

const DropdownListTariff: FC<IDropdownListTariff> = ({ data, time }) => {
  const { ordersInfo, typeOrder } = useStoreon<State, Events>('ordersInfo', 'typeOrder')
  const [tariffs, setTariffs] = useState<ITariffItem[]>([])

  const getTariffs = async () => {
    try {
      const response = await api.tariff.getActualTariff({
        time,
        date: ordersInfo.date,
        is_not_separated: true,
        side: typeOrder
      })
      setTariffs(orderRates(response))
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <>
      <div className={styles['order__container']}>
        <GxDropdown className={styles['dropdown']} onGx-show={getTariffs}>
          <GxButton className={styles['dropdown--btn']} slot='trigger'>
            <span className={styles['dropdown--btn_name']}>
              {(objectKeys(data?.sport_tariff || {}).length > 0
                ? Math.trunc(data?.sport_tariff.price)
                : 0
              ).toLocaleString()}
            </span>
          </GxButton>
          <GxMenu className={styles['dropdown--menu']}>
            <div className={styles['dropdown--menu__item']}>
              <p className={styles['dropdown--menu__item-title']}>Название</p>
              <p className={styles['dropdown--menu__item-title']}> Цена</p>
            </div>
            {tariffs.length > 0 ? (
              tariffs.map((item) => {
                return (
                  <div
                    className={styles['dropdown--menu__item']}
                    style={{ background: item.color_code }}
                    key={item.id}
                  >
                    <p>{item.rate_name}</p>
                    <p className={styles['dropdown--menu__item_price']}>
                      {Math.trunc(Number(item.price)).toLocaleString()}
                    </p>
                  </div>
                )
              })
            ) : (
              <div className={styles['dropdown--menu__item']}>
                <p>Нет ставок</p>
              </div>
            )}
          </GxMenu>
        </GxDropdown>
      </div>
    </>
  )
}

export default DropdownListTariff
